export function isIOSBrowser(): boolean {
    return (
        navigator.userAgent.indexOf('iPad') > -1 ||
        navigator.userAgent.indexOf('iPhone') > -1 ||
        navigator.userAgent.indexOf('iPod') > -1
    );
}
export abstract class HtmlUtils {
    public static delay(timeMs: number): Promise<void> {
        return new Promise((resolve) => {
            window.setTimeout(resolve, timeMs);
        });
    }

    public static nextAnimationFrame(): Promise<void> {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => resolve());
        });
    }

    public static removeAllChildren(htmlElement: HTMLElement): void {
        while (htmlElement.lastChild) {
            htmlElement.removeChild(htmlElement.lastChild);
        }
    }

    public static getNotNullElementById(id: string): HTMLElement {
        const element = document.getElementById(id);
        if (element == null) {
            throw new Error(`Html element with id "${id}" not found`);
        }
        return element;
    }

    public static async waitForElementSize(
        htmlElement: HTMLElement,
        minWidth: number,
        minHeight: number,
        timeoutMs: number
    ): Promise<{ width: number; height: number } | null> {
        const readSize = (): { width: number; height: number } => ({
            width: htmlElement.offsetWidth,
            height: htmlElement.offsetHeight,
        });

        const hasRequiredSize = (size: { width: number; height: number }): boolean => {
            return size.width >= minWidth && size.height >= minHeight;
        };

        const initialSize = readSize();
        if (hasRequiredSize(initialSize)) {
            return initialSize;
        }

        return new Promise((resolve) => {
            let resolved = false;
            let timeoutId = 0;

            const finish = (size: { width: number; height: number } | null): void => {
                if (resolved) {
                    return;
                }
                resolved = true;
                observer.disconnect();
                window.removeEventListener('resize', onResize);
                window.clearTimeout(timeoutId);
                resolve(size);
            };

            const check = (): void => {
                const nextSize = readSize();
                if (hasRequiredSize(nextSize)) {
                    finish(nextSize);
                }
            };

            const observer = new ResizeObserver(() => {
                check();
            });
            const onResize = (): void => {
                check();
            };

            observer.observe(htmlElement);
            window.addEventListener('resize', onResize);
            timeoutId = window.setTimeout(() => finish(null), timeoutMs);
            check();
        });
    }
}
